export function toHashCode(value) {
  let hash = 0;
  if (value.length === 0) {
    return hash;
  }
  for (let i = 0; i < value.length; i++) {
    const char = value.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash;
}
export function toHashHex(value) {
  return toHashCode(value).toString(16);
}
export function minify(style) {
  return style.split("\n").map((line) => line.trim()).join(" ");
}
